import React from "react";

const InvalidPage = () => {
  return <p>Kod QR yang anda guna adalah tidak sah.</p>;
};

export default InvalidPage;
